import styled, { css } from 'styled-components';

import colors from '@shared/design-tokens/colors';
import fontStyles from '@shared/design-tokens/fontStyles';

const transparent = 'transparent';

const backgroundColor = (_backgroundColor) => ({
  'background-color': _backgroundColor,
});

const borderRadius = (radius = '4px') => ({
  'border-radius': radius,
});

const borderBottom = (_borderBottomColor) => ({
  borderBottom: `2px solid ${_borderBottomColor}`,
  borderBottomColor: _borderBottomColor,
  borderBottomWidth: 2,
});

const borderFull = (_borderFullColor) => ({
  border: `2px solid ${_borderFullColor}`,
});

const borderFullNone = () => ({
  border: 'none',
});

const margin = (leftRight = 2) => ({
  'margin-left': leftRight,
  'margin-right': leftRight,
});

const baseStateCSS = css`
  ${{
    display: 'flex',
    'flex-direction': 'row',
    ...fontStyles.core.textBasis,
    'text-decoration': 'none',
  }}
`;

const defaultStateCSS = css`
  ${{
    'padding-left': 4,
    'padding-right': 4,
    'padding-top': 3,
    'padding-bottom': 2,
    ...backgroundColor(transparent),
    'border-top': `2px solid ${transparent}`,
    ...margin(2),
    color: colors.core.darkBlue,
    stroke: colors.core.darkBlue,
  }}
`;

const hoverStateCSS = css`
  ${{
    ...backgroundColor(colors.gray5),
    ...borderFullNone(),
    ...borderFull(transparent),
    ...margin(0),
    ...borderRadius(),
    color: colors.core.darkBlue,
    stroke: colors.core.gray5,
  }}
`;

const focusStateCSS = css`
  ${{
    ...backgroundColor(transparent),
    ...borderFull(colors.core.darkBlue),
    ...margin(0),
    ...borderRadius(),
    color: colors.core.darkBlue,
    stroke: colors.core.darkBlue,
  }}
`;

const activeStateCSS = css`
  ${{
    ...backgroundColor(colors.core.darkBlue),
    ...borderFull(transparent),
    ...margin(0),
    ...borderRadius(),
    color: colors.white,
    stroke: colors.white,
  }}
`;

const iconWrapperLeftComponentCSS = css`
  ${{
    'padding-left': '3.5px;',
    'padding-right': '5.5px;',
    display: 'inline',
  }}
`;

const iconWrapperRightComponentCSS = css`
  ${{
    'padding-left': '3.5px;',
    'padding-right': '5.5px;',
    display: 'inline',
  }}
`;

const borderCSS = css`
  ${{
    ...borderBottom(colors.core.darkBlue),
  }}
`;

/** styled-components */

const disableStates = css`
  padding-left: 0px !important;
  border: none !important;
  margin-left: 0px !important;
  background-color: unset !important;
  margin-right: 0px !important;
  border-radius: 0px !important;
`;

export const LinkLabel = styled.a`
  display: flex;
  align-items: center;
  ${baseStateCSS}
  ${defaultStateCSS}
  ${({ showUnderline }) => showUnderline && borderCSS}
  ${({ customTextType }) => (customTextType && fontStyles.core[customTextType] != null) && fontStyles.core[customTextType]}

  &:hover,
  &.__hover {
    ${hoverStateCSS}
  }
  &:focus,
  &.__focus {
    ${focusStateCSS}
  }
  &:active,
  &.__active {
    ${activeStateCSS}
  }

  ${({ disableAllStates }) => disableAllStates && disableStates}
`;

export const IconWrapperLeft = styled.div`
  ${iconWrapperLeftComponentCSS}
`;

export const IconWrapperRight = styled.div`
  ${iconWrapperRightComponentCSS}
`;
